import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18next
import './App.css';
import AppRouter from './AppRouter';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

// Create a client with persistent caching configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes - data considered fresh
      gcTime: 24 * 60 * 60 * 1000, // 24 hours - keep in memory and persist
      retry: 2,
      refetchOnWindowFocus: true, // Refetch when window gains focus
      refetchOnReconnect: true, // Refetch when network reconnects
      networkMode: 'offlineFirst', // Try cache first, then network
    },
  },
});

// Create persister for localStorage
const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'NIMAH_TOOLS_QUERY_CACHE',
  throttleTime: 1000, // Save to localStorage max once per second
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: localStoragePersister,
        maxAge: 7 * 24 * 60 * 60 * 1000, // 7 days - how long to keep in localStorage
        buster: 'v1.0', // Change this to invalidate all cached data when needed
      }}
    >
      <AppRouter />
    </PersistQueryClientProvider>
  </React.StrictMode>
);
